import paymentIndex from '@/pages/payments/index.vue'

export default [
  {
    path: 'payments-history',
    name: 'payments-history',
    component: paymentIndex,
    meta: {
      name: 'Payments History',
      requireAuth: true
    }
  }
]